import React from 'react';
import { Link } from 'react-router-dom';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import SVG from 'react-inlinesvg';
import { STATIC_PATH } from '../../config';

const OfferControlsModal = ({
  open,
  toggle,
  isMy,
  offerId,
  onRefuseOfferAccess,
  onRequestOfferAccess,
  onFlowCreate,
  hasPromo,
}) => {
  return (
    <Modal isOpen={open} modalClassName="offer-controls-modal" backdrop={true} toggle={toggle}>
      <ModalHeader toggle={toggle}>Действия</ModalHeader>
      <ModalBody>
        <div className="offer-controls-modal-btns">
          {isMy ? (
            <>
              <button
                className="offer-controls-modal-btn"
                onClick={onFlowCreate.bind(null, offerId)}
              >
                <SVG
                  className="item-bin-icon"
                  src={`${STATIC_PATH}/img/action-icons/plus-icon.svg`}
                  height="20"
                  width="20"
                  cacheRequests
                />
                <FormattedMessage id="offer.buttons.create-flow" defaultMessage="Create Flow" />
              </button>
              <button
                className="offer-controls-modal-btn offer-controls-modal-btn-del"
                onClick={onRefuseOfferAccess.bind(null, offerId)}
              >
                <SVG
                  className="item-bin-icon"
                  src={`${STATIC_PATH}/img/action-icons/bin-icon-2.svg`}
                  height="20"
                  width="20"
                  cacheRequests
                />
                <FormattedMessage id="offer.buttons.remove-offer" defaultMessage="Remove offer" />
              </button>
            </>
          ) : (
            <button
              className="offer-controls-modal-btn"
              onClick={onRequestOfferAccess.bind(null, offerId)}
            >
              <FormattedMessage id="offer.buttons.activate-offer" defaultMessage="Activate" />
            </button>
          )}

          {hasPromo && (
            <button className="offer-controls-modal-btn" tag={Link} to={`/offers/${offerId}/files`}>
              <FormattedMessage id="offer.buttons.promo-files" defaultMessage="Promo files" />
            </button>
          )}
        </div>
      </ModalBody>
    </Modal>
  );
};

export default OfferControlsModal;
